export const VIEW_R_BUILD_ID_META_NAME = "view-r-build-id";
export const VIEW_R_BUILD_ID_PLACEHOLDER = "__VIEWR_BUILD_ID__";

export const getClientBuildId = (
  documentLike: Pick<Document, "querySelector"> = document,
): string => {
  const value =
    documentLike
      .querySelector<HTMLMetaElement>(
        `meta[name="${VIEW_R_BUILD_ID_META_NAME}"]`,
      )
      ?.content.trim() ?? "";
  return value === VIEW_R_BUILD_ID_PLACEHOLDER ? "" : value;
};

export const shouldRequestPwaUpdate = ({
  clientBuildId,
  serverBuildId,
  storedBuildId,
}: {
  clientBuildId: string;
  serverBuildId: string;
  storedBuildId: string | null;
}): boolean => {
  if (!serverBuildId) return false;
  if (clientBuildId) return clientBuildId !== serverBuildId;
  return storedBuildId !== null && storedBuildId !== serverBuildId;
};

export const publishBuildInfo = ({
  clientBuildId,
  serverBuildId,
}: {
  clientBuildId?: string;
  serverBuildId?: string;
}): void => {
  if (clientBuildId) {
    document.documentElement.dataset.viewrClientBuildId = clientBuildId;
  }
  if (serverBuildId) {
    document.documentElement.dataset.viewrServerBuildId = serverBuildId;
  }
};
